import {combineReducers} from 'redux'
import createReportPopup from './createReportPopup/reducer'

export default combineReducers({
    createReportPopup,
})


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/reducer.js